import { P as Pagination } from './pagination-BYB1eQGc.js';
import { S as Swiper } from './index-1rH35xIi.js';
import './classes-to-selector-B0Ehowsi.js';
import './create-element-if-not-defined-CpMCDYSa.js';
import './swiper-core-ClzX336E.js';
import './a11y-BJABkpRI.js';

class FeaturedBlog extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1.15,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4.05,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
    });
  }
}

customElements.define('featured-blog-swiper', FeaturedBlog);
